import React, { useEffect, useState } from 'react';
import useReactRouter from 'use-react-router';
import { message } from 'antd';
import * as ajax from 'lib/axios';
import UpdatePassword from 'components/public-components/update-password';
import { useModuleTranslation } from '../../i18n/translation';

const ResetPassword = () => {
  const [isKeyValid, setIsKeyValid] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    history,
    match: { params },
  } = useReactRouter<{ key: string }>();
  const t = useModuleTranslation('password');

  const resetPassword = async (password: string) => {
    setIsLoading(true);
    try {
      const key = params.key;
      await ajax.handle.post('/reset-password', { password, key });
      message.success(t.reset);
      history.push('/login');
    } catch (e) {
      message.error(t.error);
      setIsLoading(false);
    }
  };

  const validateKey = async () => {
    try {
      const key = params.key;
      const { data: data } = await ajax.ignore.post('/validate-key', { key });
      if (data.code === 'SUCCESS') {
        setIsKeyValid(true);
      } else {
        setIsKeyValid(false);
      }
    } catch (e) {
      setIsKeyValid(false);
    }
  };

  useEffect(() => {
    if (location.pathname.includes('/reset-password')) validateKey();
  }, []);

  return (
    <UpdatePassword
      isKeyValid={isKeyValid}
      isLoading={isLoading}
      changePassword={resetPassword}
      isResetPassword={true}></UpdatePassword>
  );
};

export default ResetPassword;
